// Import common assets to act as central source of truth for the site
import logoImage from "./assets/NawabiCaterersLogo.jpeg";
import heroBg from "./assets/hero-bg.png";
import specialDrinks from "./assets/special-drinks.png";
import chef3 from "./assets/chef3.png";
import chef4 from "./assets/chef4.png";
import openKitchen from "./assets/open-kitchen-QYEP83V.jpg";
import fish1 from "./assets/delicious-red-salmon-fish-grilled-with-sauce-and-s-U5X74LH.jpg";
import eventCorporate from "./assets/events/Corporate.jpg";
import eventFamily from "./assets/events/Family.jpg";
import eventFestival from "./assets/events/Festival.jpg";
import eventMass from "./assets/events/MassEvents.jpg";
import eventReligious from "./assets/events/Religious.jpg";
import eventBirthday from "./assets/events/birthday.jpg";
import eventSchool from "./assets/events/school.jpg";
import reservationBgImage from "./assets/bg.jpg";
// AI-generated premium Indian imagery
import nawabiStaffTeam from "./assets/nawabi_staff_team.png";
import nawabiChefBiryani from "./assets/nawabi_chef_biryani.png";
import indianWeddingFeast from "./assets/indian_wedding_feast.png";
import indianBiryaniSpread from "./assets/indian_biryani_spread.png";
import nawabiFoodServing from "./assets/nawabi_food_serving.png";
import indianLiveCounter from "./assets/indian_live_counter.png";
import indianKebabStarters from "./assets/indian_kebab_starters.png";
import indianDesserts from "./assets/indian_desserts.png";
import nawabiHeroFeast from "./assets/nawabi_hero_feast.png";

// New high-quality menu category images
import welcomeDrinksImg from "./assets/main-images/Nawabi welcome drinks.jpg.jpeg";
import soupsImg from "./assets/main-images/Nawabi Soups.jpg.jpeg";
import breadsImg from "./assets/main-images/Nawabi Breads.jpg.jpeg";
import biryaniImg from "./assets/main-images/Nawabi Briyani.jpg.jpeg";
import riceImg from "./assets/main-images/Nawabi Rice Varieties.jpg.jpeg";
import graviesImg from "./assets/main-images/Nawabi Gravies.jpg.jpeg";
import dryItemsImg from "./assets/main-images/Nawabi Dry Items & BBQ.jpg.jpeg";
import liveCountersImg from "./assets/main-images/Nawabi live counters.jpg.jpeg";
import sweetsDessertsImg from "./assets/main-images/Nawabi Sweets & Desserts.jpg.jpeg";

export const SITE_CONTENT = {
  global: {
    logoText: "Nawabi Caterers",
    logoImage: logoImage,
    navLinks: [
      { label: "Home", to: "/" },
      { label: "About", to: "/about" },
      { label: "Menu", to: "/menu" },

      { label: "Contact", to: "/contact" },
    ],
    ctaButton: {
      label: "Book Now",
      to: "/contact",
    },
    footer: {
      brandText:
        "Nawabi's Caterers is a 100% Halal-certified premium outdoor catering brand under NonVeeFoods, delivering royal non-veg dining experiences across Tamil Nadu for all kinds of events and celebrations.",
      navLinks: [
        { label: "Home", to: "/" },
        { label: "About Us", to: "/about" },
        { label: "Our Menu", to: "/menu" },
        { label: "Salem Catering", to: "/best-catering-services-in-salem" },
        { label: "Events We Cater", to: "/blog" },
        { label: "Book Now", to: "/contact" },
      ],
      socials: [
        { id: "facebook", href: "https://facebook.com", label: "Facebook" },
        {
          id: "youtube",
          href: "https://www.youtube.com/@NawabiCaterers",
          label: "YouTube",
        },
        {
          id: "instagram",
          href: "https://instagram.com/nawabicaterers",
          label: "Instagram",
        },
      ],
      address: {
        title: "Headquarters",
        lines: ["Salem, Tamil Nadu", "India"],
      },
      contactInfo: {
        title: "Contact",
        phones: [
          { number: "+91 99527 33786", raw: "+919952733786", name: "Yacoob" },
          { number: "+91 99447 70083", raw: "+919944770083", name: "Fayaz" },
          { number: "+91 95973 28788", raw: "+919597328788", name: "Arun" },
        ],
        emails: ["nawabicaterers.support@gmail.com"],
      },
      bookTable: {
        title: "Ready for a Royal Feast?",
        text: "Book Nawabi Caterers today and let us transform your event into a grand celebration.",
        buttonText: "Book Your Event",
        buttonLink: "/contact",
      },
      bottomDocs: [
        { label: "Privacy Policy", to: "/privacy" },
        { label: "Terms & Services", to: "/terms" },
      ],
    },
  },
  pages: {
    contactUsPage: {
      pageBanner: {
        bgImage: heroBg,
        title: "Reach Out to Us",
        subtitle: "Get in Touch",
        breadcrumbs: [
          { label: "Home", to: "/" },
          { label: "Contact Us", to: "/contact" },
        ],
      },
      getInTouch: {
        subtitle: "Contact",
        title: "Get in Touch with Nawabi",
        description:
          "Whether it’s a grand wedding or a corporate event, our team is ready to deliver a royal culinary experience. Call or WhatsApp us to get your customized quote.",
        addressLines: ["Salem, Tamil Nadu", "We serve across Tamil Nadu"],
        phone: "+91 91502 99336",
        email: "nawabicaterers.support@gmail.com",
        image: specialDrinks,
      },
      contactForm: {
        subtitle: "Enquiry",
        title: "Plan Your Grand Event",
        description:
          "Provide us with your event date, location, and estimated guest count, and our team will get back to you with menu options and transparent per-plate pricing.",
        openingHours: {
          title: "Business Hours",
          days: [
            { label: "Monday - Saturday.", time: "9.00 AM - 8.00 PM" },
            { label: "Sunday.", time: "10.00 AM - 4.00 PM" },
          ],
        },
        formFields: [
          { type: "text", placeholder: "Your Name" },
          { type: "email", placeholder: "Your Email" },
          { type: "tel", placeholder: "Your Phone Number" },
        ],
        textAreaPlaceholder: "Event Details (Date, Location, Guest Count)",
        buttonText: "Send Enquiry",
      },
      mapSection: {
        title: "Our Location",
        mapSrc:
          "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15632.748057279316!2d78.1408104!3d11.6491763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf1c080000001%3A0x6b1064e43e74ff1f!2sSalem%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1714571987541!5m2!1sen!2sin",
      },
    },
    aboutUsPage: {
      pageBanner: {
        bgImage: heroBg,
        eyebrow: "A Legacy of Flavours",
        title: "About Nawabi Caterers",
        breadcrumbs: [
          { label: "Home", to: "/" },
          { label: "About Us", to: "/about" },
        ],
      },
      intro: {
        subtitle: "Our Story",
        title: "Born in Tamil Nadu",
        titleItalic: "Built for Grand Occasions",
        paragraphs: [
          "Nawabi Caterers is the outdoor catering arm of NonVeeFoods, Tamil Nadu's trusted name in non-vegetarian food. We bring the richness of Nawabi culinary traditions — elevated with the bold, spiced heritage of Tamil Nadu — to every plate we serve.",
          "From intimate family gatherings to grand wedding feasts with thousands of guests, our master chefs and service professionals ensure every event is nothing short of royal.",
        ],
        quote: {
          image: chef3,
          text: '"Every event deserves a feast worthy of royalty. We don\'t just cook food — we craft experiences that your guests will savour in memory long after the celebration ends."',
          author: "A NonVeeFoods Brand",
        },
      },
      ourTeam: {
        subtitle: "Our Chefs",
        title: "Masters of Authentic Cuisine",
        teamMembers: [
          {
            name: "Chef Tamil",
            role: "Chettinad Specialist",
            image: nawabiStaffTeam,
            socials: { facebook: "#", twitter: "#", linkedin: "#" },
          },
          {
            name: "Chef Rahman",
            role: "Mughlai & Biryani Master",
            image: nawabiChefBiryani,
            socials: { facebook: "#", twitter: "#", linkedin: "#" },
          },
          {
            name: "Chef Murugan",
            role: "Coastal Seafood Expert",
            image: chef3,
            socials: { facebook: "#", twitter: "#", linkedin: "#" },
          },
          {
            name: "Chef Meena",
            role: "Dessert & Banquets Lead",
            image: chef4,
            socials: { facebook: "#", twitter: "#", linkedin: "#" },
          },
        ],
      },
      imageCarousel: {
        defaultImages: [
          indianWeddingFeast,
          indianBiryaniSpread,
          indianLiveCounter,
          indianKebabStarters,
          nawabiFoodServing,
          indianDesserts,
          nawabiStaffTeam,
          nawabiChefBiryani,
        ],
      },
      experienceSection: {
        subtitle: "The Nawabi Difference",
        title: "The Full Royal Experience",
        buttonText: "Book Us Now",
        experiences: [
          {
            label: "The Foundation",
            title: "Farm-Fresh Daily",
            description:
              "We source fresh meat, seafood, and produce daily. Zero frozen shortcuts. Every dish is prepared on-site for maximum freshness.",
            image: indianBiryaniSpread,
            alt: "Fresh Indian feast spread",
            to: "/contact",
          },
          {
            label: "The Execution",
            title: "Full Outdoor Setup",
            description:
              "We bring everything — mobile kitchen, live counters, serving equipment, and trained service staff directly to your venue.",
            image: indianLiveCounter,
            alt: "Live outdoor cooking counter at Indian event",
            to: "/contact",
          },
          {
            label: "The Guarantee",
            title: "FSSAI Certified",
            description:
              "Certified food safety standards, hygienically packed utensils, gloved service staff, and clean practices at every single event.",
            image: nawabiFoodServing,
            alt: "Royal serving at Indian wedding event",
            to: "/contact",
          },
        ],
      },
      statsSection: {
        stats: [
          { end: 1000, suffix: "+", label: "Events Delivered", decimal: false },
          { end: 25, suffix: "+", label: "Years of Legacy", decimal: false },
          { end: 5, suffix: "L+", label: "Guests Served", decimal: false },
          { end: 25, suffix: "+", label: "Cities Covered", decimal: false },
          {
            end: 100,
            suffix: "%",
            label: "Fresh and Hygienic",
            decimal: false,
          },
        ],
      },
    },
    homePage: {
      seo: {
        title: "Nawabi Caterers | Best Biryani & Non-Veg Catering in Tamil Nadu",
        description: "Nawabi Caterers provides premium non-veg and biryani outdoor catering for weddings, parties, and corporate functions across Salem, Chennai, Coimbatore, and Tamil Nadu. Request a quote today!",
        keywords: "Nawabi Caterers, non veg catering Salem, biryani catering Tamil Nadu, wedding caterers Salem, outdoor catering Chennai, corporate catering Coimbatore",
        canonical: "https://www.nawabicaterers.com/",
        og: {
          type: "website",
          url: "https://www.nawabicaterers.com/",
          title: "Nawabi Caterers | Premium Biryani & Non-Veg Catering in Tamil Nadu",
          description: "Specialist non-vegetarian and biryani catering for weddings, parties, and corporate functions across Salem, Chennai, Coimbatore, and Tamil Nadu.",
          image: "https://www.nawabicaterers.com/images/og-banner.jpg",
          imageAlt: "Nawabi Caterers Biryani and Non-Veg Catering Setup",
          siteName: "Nawabi Caterers",
          locale: "en_IN"
        }
      },
      heroSection: {
        headline: "Searching for the Best Catering Service Near Me? Nawabi Caterers Has Your Event Covered",
        description: "Nawabi Caterers is an outdoor catering brand from the NonVeeFoods family, specialising in non-vegetarian food and biryani for weddings, receptions, corporate events and family celebrations across Tamil Nadu. From an intimate house function to a large wedding reception, we plan the menu, cook on site and serve your guests, so you get to enjoy the day instead of running it. Tell us your date, your headcount and the food you love, and we'll take care of the rest.",
        primaryButton: {
          label: "Request a Catering Quote",
          to: "#booking-section"
        },
        secondaryButton: {
          label: "Call or WhatsApp Us to Discuss Your Event",
          phone: "+919150299336",
          whatsappUrl: "https://wa.me/919150299336?text=Hi%20Nawabi%20Caterers,%20I%20would%20like%20to%20discuss%20catering%20for%20my%20event."
        },
        slides: [
          { image: nawabiHeroFeast, alt: "Grand Indian Wedding Banquet by Nawabi's" },
          { image: indianWeddingFeast, alt: "Royal feast at Indian catering event" },
          { image: nawabiFoodServing, alt: "Nawabi staff serving royal feast" },
          { image: indianBiryaniSpread, alt: "Authentic Dum Biryani Feast Spread" }
        ],
        badges: [
          "100% Halal Certified",
          "Cooked Fresh On-Site",
          "Outdoor Catering Specialists",
          "Salem · Chennai · Coimbatore & All TN"
        ]
      },
      introSection: {
        title: "Why Choose Nawabi Caterers When You Search for a Catering Service Near You",
        paragraphs: [
          "When you look up a catering service near me, you're usually after three things: food that tastes great, a team that shows up and runs the day smoothly, and a menu that fits your event and your budget. Nawabi Caterers is built around exactly that.",
          "We're an outdoor catering service, which means we bring the kitchen and the crew to your venue, including wedding halls, farmhouses, community grounds, homes or corporate spaces. Our strength is non-veg and biryani-led menus, cooked in the quantities your gathering needs and served hot.",
          "Every event is different, so nothing is off-the-shelf. We sit down with you, understand the occasion and the guest count, and build a customised menu around it. Whether it's a wedding for several hundred guests or a birthday lunch at home, the approach is the same: get the food right, and get the service right.",
          "We're based in Salem and cater for events across Tamil Nadu, including Chennai and Coimbatore. If your town isn't listed, just ask, and we'll let you know whether we can cover your date."
        ]
      },
      servicesSection: {
        title: "Our Catering Services",
        subtitle: "Each event gets a menu and a service plan suited to it.",
        services: [
          {
            id: "wedding-catering",
            title: "Wedding Catering",
            description: "Weddings are our biggest events, and we treat them that way. We plan multi-course menus, coordinate serving for large guest counts, and manage everything from the main biryani to starters, gravies and desserts. Buffet or seated service, we set it up to match your hall and your schedule.",
            ctaText: "See how our wedding catering works",
            ctaLink: "#wedding-spotlight",
            image: indianWeddingFeast
          },
          {
            id: "non-veg-catering",
            title: "Non-Veg Catering",
            description: "Non-vegetarian food is what we're known for. Chicken and mutton dishes, biryani, rich gravies and rice varieties form the core of our menus. If you want a spread that leans heavily on non-veg, this is where we're most at home.",
            ctaText: "Explore non-veg catering options",
            ctaLink: "#non-veg-spotlight",
            image: indianKebabStarters
          },
          {
            id: "biryani-catering",
            title: "Biryani Catering",
            description: "Biryani is a crowd favourite for a reason. It travels well, serves large numbers and keeps guests happy. We prepare biryani in event quantities without losing the flavour, and pair it with the sides that go with it.",
            ctaText: "Ask about biryani catering for your event",
            ctaLink: "#biryani-spotlight",
            image: biryaniImg
          },
          {
            id: "corporate-catering",
            title: "Corporate Catering",
            description: "For office events, meetings, launches and staff functions, we provide catering that's easy to organise and dependable to serve. Share the headcount and the time slot, and we'll plan a menu that works for a corporate setting.",
            ctaText: "Plan corporate catering",
            ctaLink: "#booking-section",
            image: eventCorporate
          },
          {
            id: "birthday-party-catering",
            title: "Birthday & Party Catering",
            description: "Birthdays, anniversaries and get-togethers call for food people remember. We put together party menus for small and mid-sized gatherings, at home or at a venue, with the flexibility to keep it simple or make it a spread.",
            ctaText: "Get a party catering quote",
            ctaLink: "#booking-section",
            image: eventBirthday
          },
          {
            id: "family-religious-catering",
            title: "Family & Religious Function Catering",
            description: "Naming ceremonies, housewarmings, religious gatherings and family functions each have their own rhythm. We cater these with menus that suit the occasion and serving that respects the setting.",
            ctaText: "Discuss your function",
            ctaLink: "#booking-section",
            image: eventReligious
          },
          {
            id: "large-scale-catering",
            title: "Large-Scale & Event Catering",
            description: "For big gatherings, including large weddings, community events and mass functions, the challenge is volume without dropping quality. We plan quantities carefully and staff the event to serve everyone properly.",
            ctaText: "Talk to us about large events",
            ctaLink: "#booking-section",
            image: eventMass
          }
        ]
      },
      spotlights: {
        wedding: {
          id: "wedding-spotlight",
          title: "Wedding Catering Service Near You",
          intro: "A wedding is the one event where the food gets remembered and talked about long after the day. That's why our wedding catering starts with a proper conversation, not a fixed menu.",
          pillars: [
            {
              title: "Menu planning built around your wedding",
              description: "We work with you to shape a menu that fits the style of your wedding, your family's preferences and your budget. Biryani and non-veg dishes usually anchor the spread, with starters, rice varieties, gravies and desserts filling it out. Want something specific? Tell us and we'll plan for it."
            },
            {
              title: "Cooking for the right guest count",
              description: "Catering for a hundred guests and catering for a thousand are different jobs. We plan quantities around your confirmed headcount so there's enough for everyone, with the comfortable buffer a wedding needs."
            },
            {
              title: "Buffet and serving arrangements",
              description: "Depending on your hall and the flow of the event, we set up buffet counters or arrange served meals. We'll advise on what works best for your venue and guest movement."
            },
            {
              title: "Service staff and event coordination",
              description: "Our team handles the on-site setup, cooking and serving, and works to your event timeline so the food is ready when your guests are. You focus on the wedding; we'll run the catering."
            }
          ],
          ctaText: "Planning a wedding? Request a wedding catering quote",
          ctaLink: "#booking-section",
          image: indianWeddingFeast
        },
        nonVeg: {
          id: "non-veg-spotlight",
          title: "Non-Veg Catering Services Near You",
          intro: "Non-vegetarian catering is the heart of what Nawabi Caterers does. If your event calls for a non-veg spread that satisfies, this is our specialty. Our non-veg menus are typically built around:",
          items: [
            "Biryani, the centrepiece of most of our events",
            "Chicken dishes, a range of preparations to suit the occasion",
            "Mutton dishes, for a richer, festive spread",
            "Gravies and curries, to pair with rice and breads",
            "Rice varieties, beyond biryani, to round out the meal"
          ],
          note: "The exact dishes are planned with you, so your menu matches the event, whether it is a wedding, a corporate lunch, a birthday or a family function. If you have particular preferences or requirements for how the food is prepared, let us know when you enquire and we'll build the menu accordingly. Live counters can also be arranged for events that call for them. Just ask what's possible for your date.",
          ctaText: "Build your non-veg menu",
          ctaLink: "#booking-section",
          image: dryItemsImg
        },
        biryani: {
          id: "biryani-spotlight",
          title: "Biryani Catering Near You",
          intro: "Ask any host what keeps guests happy, and biryani is near the top of the list. It's filling, it's festive, and it works for almost any occasion, which is why biryani catering is one of our most requested services. Biryani suits just about every event we cater:",
          occasions: [
            "Weddings and receptions, as the main dish of the meal",
            "Birthdays and parties, an easy, reliable crowd-pleaser",
            "Corporate events, when you need to feed a group well without fuss",
            "Family and religious functions, as a shared centrepiece",
            "Large gatherings, where it serves big numbers dependably"
          ],
          note: "What matters with event biryani is getting three things right: preparation, flavour and quantity. We cook in event-sized batches while keeping the taste consistent, plan portions around your headcount, and serve it hot so it reaches your guests at its best.",
          ctaText: "Ask about biryani catering for your date",
          ctaLink: "#booking-section",
          image: nawabiChefBiryani
        }
      },
      whyHostsChoose: {
        title: "Why Hosts Choose Nawabi Caterers",
        subtitle: "Here's what you can expect when you cater with us.",
        items: [
          {
            number: "01",
            title: "We specialise in non-veg and biryani",
            description: "This isn't a side offering. Non-veg and biryani are our focus, and our menus are built around getting them right."
          },
          {
            number: "02",
            title: "Menus customised to your event",
            description: "Nothing is fixed. We plan your menu around the occasion, the guest count and your preferences, so it fits your event rather than the other way round."
          },
          {
            number: "03",
            title: "Outdoor catering, brought to your venue",
            description: "As an outdoor catering service, we come to you, including halls, farmhouses, homes, grounds or corporate spaces across Tamil Nadu."
          },
          {
            number: "04",
            title: "A team that handles the whole event",
            description: "From setup and cooking to serving, our staff run the catering on the ground, so you can be a host rather than a manager on your big day."
          },
          {
            number: "05",
            title: "Built for events of different sizes",
            description: "Whether it's a family lunch or a large wedding, we plan and staff accordingly. The scale changes; the care doesn't."
          },
          {
            number: "06",
            title: "Attention to freshness and hygiene",
            description: "Food is cooked for your event, with care taken over freshness and clean handling from preparation through to serving."
          },
          {
            number: "07",
            title: "Part of the NonVeeFoods family",
            description: "Nawabi Caterers is a brand under NonVeeFoods, our non-vegetarian food business, so catering is a natural extension of what we already do."
          }
        ]
      },
      howItWorks: {
        title: "How Our Catering Service Works",
        steps: [
          {
            number: "1",
            title: "Tell us about your event",
            description: "Share the date, venue, type of occasion and a rough guest count."
          },
          {
            number: "2",
            title: "Discuss the menu and numbers",
            description: "We talk through food preferences, non-veg and biryani options, and confirm your headcount."
          },
          {
            number: "3",
            title: "Customise your catering plan",
            description: "We shape a menu and service setup to fit your event and budget, and share a quote."
          },
          {
            number: "4",
            title: "We prepare and set up",
            description: "On the day, our team arrives, sets up and cooks on site at your venue."
          },
          {
            number: "5",
            title: "We serve your guests",
            description: "Buffet or served, we handle the serving so every guest is looked after."
          }
        ]
      },
      serviceAreasSection: {
        subtitle: "We Serve Across",
        title: "Tamil Nadu Wide Coverage",
        areas: [
          "Salem",
          "Chennai",
          "Coimbatore",
          "Erode",
          "Madurai",
          "Trichy",
          "Namakkal",
          "Dharmapuri",
          "Krishnagiri",
          "Tirupur",
          "Vellore",
          "Thanjavur",
          "Tirunelveli",
          "Kumbakonam",
          "Hosur",
          "Ooty"
        ],
        note: "We travel beyond - enquire for outstation event catering availability"
      },
      cateringMenu: {
        title: "A Look at Our Catering Menu",
        subtitle: "Our menus are put together for each event, but they're generally built from these categories. Your final menu is planned with you when you enquire.",
        categories: [
          { name: "Biryani, the centrepiece of most of our events", image: biryaniImg },
          { name: "Non-veg main courses, chicken and mutton preparations", image: graviesImg },
          { name: "Starters, to open the meal", image: dryItemsImg },
          { name: "Rice varieties, beyond biryani", image: riceImg },
          { name: "Gravies and curries, to pair with rice and breads", image: graviesImg },
          { name: "Desserts, to finish the meal", image: sweetsDessertsImg },
          { name: "Beverages, to accompany the spread", image: welcomeDrinksImg }
        ],
        liveCounterNote: "Prefer a live counter or a particular dish at your event? Mention it when you enquire and we'll tell you what we can arrange.",
        ctaText: "Discuss your menu with us",
        ctaLink: "#booking-section"
      },
      eventsWeCater: {
        title: "Events We Cater",
        items: [
          "Weddings and receptions",
          "Birthday celebrations and anniversaries",
          "Corporate events and office functions",
          "Family functions, housewarmings, naming ceremonies and more",
          "Religious gatherings",
          "School and college events",
          "Public and mass gatherings",
          "Festival celebrations"
        ],
        note: "If your event isn't on this list, ask. If it involves feeding a crowd, we can probably help.",
        ctaText: "Book Your Royal Feast enquiry form",
        ctaLink: "#booking-section"
      },
      testimonials: {
        subtitle: "In Our Clients Words",
        title: "What Our Clients Say",
        reviews: [
          {
            quote: "We booked Nawabi Caterers for our wedding reception in Coimbatore with over 700 guests. The mutton biryani was exceptional, cooked fresh right at the venue and served piping hot to every table. Their team managed the outdoor setup effortlessly, and our guests are still raving about the starters.",
            author: "Anand & Divya · Wedding Reception · Coimbatore"
          },
          {
            quote: "Organized a corporate offsite in Salem, and Nawabi Caterers handled the entire lunch spread. They were punctual, extremely professional, and the non-veg curry and biryani setup suited our corporate environment perfectly. They made the whole process completely hassle-free.",
            author: "Praveen K., Senior Operations Manager · Corporate Event · Salem"
          },
          {
            quote: "We needed non-veg catering for a housewarming function in Chennai for 120 guests. Nawabi Caterers customized the entire menu around our family's preferences, from the chicken starters to the desserts. Everything was prepared fresh on site, perfectly spiced, and served with great care.",
            author: "Meenakshi Sundaram · Family Function · Chennai"
          }
        ]
      },
      faqs: {
        title: "Frequently Asked Questions",
        items: [
          {
            q: "How do I find the best catering service near me for my event?",
            a: "Start by matching the caterer to your event. If you want a non-veg or biryani-led spread for a wedding, party or corporate function in and around Salem or across Tamil Nadu, Nawabi Caterers is a good fit. The quickest way to know is to send us your date and guest count for a quote."
          },
          {
            q: "Do you provide wedding catering?",
            a: "Yes. Weddings are our biggest events. We plan the menu, cook on site and serve your guests, with biryani and non-veg dishes usually at the centre of the meal."
          },
          {
            q: "Do you provide non-veg catering?",
            a: "Yes, non-vegetarian food is our specialty. Chicken, mutton, biryani, gravies and rice varieties form the core of our menus, planned around your event."
          },
          {
            q: "Do you provide biryani catering?",
            a: "Yes. Biryani is one of our most requested services, prepared in event quantities and served hot for gatherings of all sizes."
          },
          {
            q: "Do you offer outdoor catering?",
            a: "Yes. We're an outdoor catering service, so we bring the kitchen and team to your venue, including halls, farmhouses, homes, grounds or corporate spaces."
          },
          {
            q: "Can I customise the menu?",
            a: "Absolutely. Menus aren't fixed. We plan them with you around the occasion, guest count, preferences and budget. If you have specific requirements, tell us when you enquire."
          },
          {
            q: "Which locations do you serve?",
            a: "We're based in Salem and cater across Tamil Nadu, including Chennai and Coimbatore. For other areas, contact us with your location and date and we'll confirm availability."
          },
          {
            q: "Can you cater for large gatherings?",
            a: "Yes. We plan quantities and staff for large weddings, community events and mass functions, so everyone is served properly."
          },
          {
            q: "How do I request a catering quotation?",
            a: "Send us your event date, venue, type of occasion and a rough guest count, by call, WhatsApp or the enquiry form, and we'll put together a quote."
          },
          {
            q: "How early should I book catering for an event?",
            a: "Earlier is better, especially for weddings and peak-season dates, so your date is secured and there's time to plan the menu. As soon as your date and venue are set, reach out."
          }
        ]
      },
      finalCta: {
        title: "Ready to Plan Your Event? Let's Talk Food.",
        description: "Whether it's a wedding, a birthday, a corporate function or a family celebration, Nawabi Caterers is ready to plan a non-veg and biryani spread your guests will remember. Tell us about your event, share your guest count, and we'll build a menu and a quote around it.",
        primaryButton: {
          label: "Request a Catering Quote",
          to: "#booking-section"
        },
        secondaryButton: {
          label: "Call or WhatsApp Us to Discuss Your Event",
          phone: "+919150299336",
          whatsappUrl: "https://wa.me/919150299336?text=Hi%20Nawabi%20Caterers,%20I%20would%20like%20to%20discuss%20catering%20for%20my%20event."
        }
      },
reservationSection: {
        backgroundImage: reservationBgImage,
        subtitle: "Enquiry",
        title: "Book Your Royal Feast",
        description:
          "Provide your details, choose your event info, and build your custom Halal menu — all in three easy steps.",
        buttonText: "Submit Enquiry",
        menuBuilder: {
          welcomeDrinks: {
            id: "welcome",
            icon: "🥤",
            label: "Welcome Drinks",
            subtitle: "Choose the beverages to greet your guests",
            items: [
              {
                id: "w1",
                name: "Saffron Lassi",
                desc: "Thick sweet yogurt drink infused with premium saffron",
              },
              {
                id: "w2",
                name: "Rose Sharbat",
                desc: "Chilled refreshing rose-flavoured welcome drink",
              },
              {
                id: "w3",
                name: "Masala Chaas",
                desc: "Spiced buttermilk with roasted cumin and mint",
              },
              {
                id: "w4",
                name: "Fresh Lime Soda",
                desc: "Sweet or salted chilled lime soda",
              },
              {
                id: "w5",
                name: "Watermelon Juice",
                desc: "Fresh seasonal fruit punch",
              },
              {
                id: "w6",
                name: "Tender Coconut Water",
                desc: "Natural tender coconut served fresh",
              },
              {
                id: "w7",
                name: "Badam Milk",
                desc: "Chilled almond milk with cardamom and saffron",
              },
              {
                id: "w8",
                name: "Jaljeera",
                desc: "Tangy cumin-based refreshing drink",
              },
            ],
          },
          starters: {
            id: "starters",
            icon: "🍗",
            label: "Starters & Kebabs",
            subtitle:
              "Select your appetisers — served hot from our live counters",
            items: [
              {
                id: "s1",
                name: "Chicken Tandoori & Tikka",
                desc: "Clay oven roasted chicken in yogurt & spice marinade",
              },
              {
                id: "s2",
                name: "Seekh & Reshmi Kebab",
                desc: "Minced meat skewers grilled to smoky perfection",
              },
              {
                id: "s3",
                name: "Mutton Boti Kebab",
                desc: "Tender mutton cubes slow-grilled with bold spices",
              },
              {
                id: "s4",
                name: "Prawn Masala Fry",
                desc: "Fresh Halal prawns pan-fried in a spicy masala",
              },
              {
                id: "s5",
                name: "Vanjaram Fish Fry",
                desc: "Seer fish slices in traditional spice coating",
              },
              {
                id: "s6",
                name: "Chicken 65",
                desc: "Crispy deep-fried chicken — the ultimate crowd-pleaser",
              },
              {
                id: "s7",
                name: "Chicken Lollipop",
                desc: "Spicy glazed chicken wings, perfect party starter",
              },
              {
                id: "s8",
                name: "Egg Pepper Fry",
                desc: "Boiled eggs tossed in sharp pepper and fennel masala",
              },
              {
                id: "s9",
                name: "Squid Fry (Calamari)",
                desc: "Crispy spiced squid rings from our live counter",
              },
            ],
          },
          mainCourse: {
            id: "main",
            icon: "🍛",
            label: "Main Course",
            subtitle:
              "Build your main feast — biryanis, curries, breads & more",
            items: [
              {
                id: "m1",
                name: "Nawabi Chicken Biryani",
                desc: "Signature saffron biryani slow-cooked to perfection",
              },
              {
                id: "m2",
                name: "Mutton Dum Biryani",
                desc: "Succulent mutton layered with fragrant basmati rice",
              },
              {
                id: "m3",
                name: "Prawn & Fish Biryani",
                desc: "Coastal style biryani with fresh Halal seafood",
              },
              {
                id: "m4",
                name: "Thalappakatti Style Biryani",
                desc: "Authentic Dindigul style with Seeraga Samba rice",
              },
              {
                id: "m5",
                name: "Nawabi Chicken Korma",
                desc: "Rich creamy gravy with almond, cashew and spices",
              },
              {
                id: "m6",
                name: "Chettinad Chicken Curry",
                desc: "Spicy aromatic chicken with roasted Chettinad masala",
              },
              {
                id: "m7",
                name: "Mutton Rogan Josh",
                desc: "Deeply spiced Kashmiri-style braised mutton",
              },
              {
                id: "m8",
                name: "Coastal Fish Curry",
                desc: "Tangy tamarind and coconut milk fish gravy",
              },
              {
                id: "m9",
                name: "Prawn Masala Gravy",
                desc: "Juicy Halal prawns in thick onion-tomato gravy",
              },
              {
                id: "m10",
                name: "Naan, Kulcha & Parotta",
                desc: "Fresh tandoori breads and flaky South Indian parottas",
              },
              {
                id: "m11",
                name: "Ghee Rice & Jeera Rice",
                desc: "Aromatic tempered rice rich in pure desi ghee",
              },
              {
                id: "m12",
                name: "Shahi Tukda & Gulab Jamun",
                desc: "Royal Mughlai sweets to finish the feast",
              },
            ],
          },
        },
      },
      aboutSection: {
        images: {
          main: indianWeddingFeast,
          mainAlt: "Grand Indian wedding catering feast",
          overlap: nawabiStaffTeam,
          overlapAlt: "Nawabi Caterers professional team",
        },
        eyebrow: "Our Story",
        headingPart1: "A Legacy of",
        headingPart2: "Royal Flavours",
        paragraphs: [
          "Nawabi Caterers is the outdoor catering arm of NonVeeFoods, Tamil Nadu's trusted name in non-vegetarian food. We bring the richness of Nawabi culinary traditions — elevated with the bold, spiced heritage of Tamil Nadu — to every plate we serve.",
          "From intimate family gatherings to grand wedding feasts with thousands of guests, our master chefs and service professionals ensure every event is nothing short of royal.",
        ],
        quote: {
          text: '"Every event deserves a feast worthy of royalty. We don\'t just cook food — we craft experiences that your guests will savour."',
          author: "A NonVeeFoods Brand",
        },
        button: {
          label: "Discover Our Promise",
          to: "/about",
        },
      },
      whyChooseUsSection: {
        subtitle: "Why Choose Nawabi's",
        title: "The Nawabi's Difference",
        description:
          "What sets us apart is not just the food — it's the full royal experience we deliver from planning to the last plate served.",
        features: [
          {
            number: "01",
            title: "100% Halal Certified",
            description:
              "Every ingredient, every cut of meat, and every dish we prepare is strictly 100% Halal. We follow verified Halal slaughter practices and never compromise on our commitment to purity.",
          },
          {
            number: "02",
            title: "Master Chefs, Authentic Recipes",
            description:
              "Our chefs specialise in authentic Tamil Nadu, Mughal, and Chettinad non-veg cuisines with decades of experience in large-scale outdoor catering.",
          },
          {
            number: "03",
            title: "Full Outdoor Setup",
            description:
              "We bring everything — mobile kitchen, live counters, serving equipment, décor-ready food stations, and trained service staff to your venue.",
          },
          {
            number: "04",
            title: "Farm-Fresh Ingredients Daily",
            description:
              "We source fresh Halal meat, seafood, and produce daily. Zero frozen shortcuts. Every dish is prepared on-site for maximum freshness and taste.",
          },
          {
            number: "05",
            title: "Customised Menu Planning",
            description:
              "Your event is unique. We create custom packages aligned with your event theme, region, guest profile, and budget.",
          },
          {
            number: "06",
            title: "FSSAI Certified & Hygienic",
            description:
              "Certified food safety standards, hygienically packed utensils, gloved service staff, and clean Halal kitchen practices at every event.",
          },
          {
            number: "07",
            title: "Transparent Pricing",
            description:
              "No hidden charges. Clear per-plate pricing with detailed quotations so you know exactly what you're getting before you book.",
          },
          {
            number: "08",
            title: "On-Time, Every Time",
            description:
              "Our logistics team ensures setup is complete and serving begins at your exact requested time — always, without fail.",
          },
          {
            number: "09",
            title: "Post-Event Cleanup",
            description:
              "We don't leave a mess behind. Our team handles complete post-event cleanup so you focus only on your celebration.",
          },
        ],
      },
      featuresSection: {
        features: [
          {
            number: "01",
            title: "Master Chefs",
            description:
              "Specialists in authentic Tamil Nadu, Mughal, and Chettinad cuisines with decades of large-scale catering experience.",
            cta: "View Our Chefs",
            to: "/about",
          },
          {
            number: "02",
            title: "Customised Menus",
            description:
              "Your event is unique. We create custom packages aligned with your theme, region, guest profile, and budget.",
            cta: "See The Menu",
            to: "/menu",
          },
          {
            number: "03",
            title: "Any Event, Anywhere",
            description:
              "We cater for weddings, corporate events, religious functions and mass melas all across Tamil Nadu.",
            cta: "Book Today",
            to: "/contact",
          },
        ],
      },
      visitSection: {
        title: "Ready for a Feast?",
        addressLines: [
          "Serving dynamically across",
          "Tamil Nadu, from Chennai to Coimbatore",
        ],
        phone: "+91 91502 99336",
        email: "nawabicaterers.support@gmail.com",
        button: { label: "Request a Quote", to: "/contact" },
        images: {
          left: indianWeddingFeast,
          leftAlt: "Grand Indian wedding catering setup",
          rightTop: indianKebabStarters,
          rightTopAlt: "Premium Indian kebab starters platter",
          rightBottom: nawabiFoodServing,
          rightBottomAlt: "Nawabi staff serving guests at event",
        },
      },
      ctaSection: {
        title: "Ready to Feast Like Royalty?",
        description:
          "Book Nawabi Caterers today and let us transform your event into a grand, flavour-filled celebration your guests will remember forever.",
        buttons: [
          { text: "Call to Book", link: "tel:+919150299336", primary: true },
          {
            text: "WhatsApp Us",
            link: "https://wa.me/919150299336",
            primary: false,
          },
        ],
        contactLabel: "Call / WhatsApp",
        contactNumber: "+91 91502 99336",
        footerText: "nawabicaterers.support@gmail.com",
      },
      signatureSection: {
        subtitle: "Our Specialties",
        title: "A Glimpse of the Nawabi Menu",
        button: {
          label: "View Full Menu",
          to: "/menu",
        },
        dishes: [
          {
            title: "Signature Biryanis",
            description:
              "From Nawabi Chicken Biryani to Ambur Star and Mutton Dum, our biryanis are slow-cooked to aromatic perfection.",
            image: indianBiryaniSpread,
            alt: "Signature Biryanis platter",
            span: "col-span-1",
            tall: true,
          },
          {
            title: "Seafood Specials",
            description:
              "Fresh Vanjaram Fish Fry, Lobster Masala, Crab Pepper Masala and authentic Karimeen Pollichathu.",
            image: fish1,
            alt: "Spicy South Indian Fish Fry",
            span: "col-span-1",
            tall: true,
          },
          {
            title: "Starters & Kebabs",
            description:
              "Smoky Chicken Tandoori, Seekh Kebabs, and classic Chicken 65 live from our event counters.",
            image: indianKebabStarters,
            alt: "Starters and Kebabs platter",
            span: "col-span-1",
            tall: false,
          },
        ],
      },
      instagramSection: {
        subtitle: "Follow Us",
        title: "Taste the Experience",
        handle: "@nawabicaterers",
        url: "https://instagram.com/nawabicaterers",
        photos: [
          { src: indianWeddingFeast, alt: "Grand Indian wedding feast" },
          { src: indianLiveCounter, alt: "Live kebab counter at event" },
          { src: indianBiryaniSpread, alt: "Mutton dum biryani spread" },
          { src: indianKebabStarters, alt: "Indian kebab starters platter" },
          { src: nawabiFoodServing, alt: "Royal serving at wedding" },
          { src: indianDesserts, alt: "Traditional Indian desserts" },
        ],
      },
      blogSection: {
        subtitle: "Our Services",
        title: "Every Celebration, Every Scale",
        button: { label: "Enquire for Your Event", to: "/contact" },
        posts: [
          {
            image: nawabiFoodServing,
            alt: "Grand Wedding catering",
            category: "Weddings",
            date: "Premium Service",
            title: "Weddings & Receptions",
            excerpt:
              "Grand wedding feasts for all ceremonies — Nichayathartham, Kalyanam & Reception",
            to: "/contact",
          },
          {
            image: eventBirthday,
            alt: "Birthday party gatherings",
            category: "Birthdays",
            date: "Live Counters",
            title: "Birthday Parties",
            excerpt:
              "Memorable birthday banquets with live counters and themed food setups",
            to: "/contact",
          },
          {
            image: eventCorporate,
            alt: "Corporate team lunch",
            category: "Corporate",
            date: "Professional Setup",
            title: "Corporate Events",
            excerpt:
              "Team lunches, client dinners, office parties & product launch events",
            to: "/contact",
          },
          {
            image: eventReligious,
            alt: "Religious ceremonies food setup",
            category: "Functions",
            date: "Traditional Spreads",
            title: "Religious Ceremonies",
            excerpt:
              "Sadangu, Seemantham, House warming & all family religious functions",
            to: "/contact",
          },
          {
            image: eventSchool,
            alt: "College & School catering",
            category: "Institutions",
            date: "Mass Catering",
            title: "College & School Events",
            excerpt:
              "Annual day, farewell parties, cultural fests & large institutional gatherings",
            to: "/contact",
          },
          {
            image: eventMass,
            alt: "Mass events",
            category: "Public Events",
            date: "Large Scale",
            title: "Mass Events & Melas",
            excerpt:
              "Public events, political gatherings, sports events & large-scale outdoor feasts",
            to: "/contact",
          },
          {
            image: eventFestival,
            alt: "Festival feasts",
            category: "Festivals",
            date: "Festive Banquets",
            title: "Festival Catering",
            excerpt:
              "Eid, Pongal, Christmas & all major festival banquets with traditional spreads",
            to: "/contact",
          },
          {
            image: eventFamily,
            alt: "Family gatherings",
            category: "Family",
            date: "Intimate Feasts",
            title: "Family Gatherings",
            excerpt:
              "Reunion dinners, ear-piercing, puberty functions & intimate family feasts",
            to: "/contact",
          },
        ],
      },
    },
    menuPage: {
      pageBanner: {
        bgImage: heroBg,
        eyebrow: "A Treat for Your Guests",
        title: "The Nawabi Menu",
        breadcrumbs: [
          { label: "Home", to: "/" },
          { label: "Menu", to: "/menu" },
        ],
      },
      intro: {
        eyebrow: "Fully Customizable",
        title: "Carefully Curated",
        titleItalic: "Non-Veg Delicacies",
      },
      menuImages: {
        default: openKitchen,
      },
      sections: [
        {
          id: "welcome-drinks",
          icon: "🥤",
          image: welcomeDrinksImg,
          label: "Welcome Drinks",
          items: [
            {
              name: "Fruit Punch",
              desc: "A refreshing blend of seasonal fresh fruits served chilled.",
              price: "On Request",
            },
            {
              name: "Mojito – Mint / Blueberry",
              desc: "Fresh mint or blueberry mojito, a perfect welcome cooler.",
              price: "On Request",
            },
            {
              name: "Kulki Sarabath",
              desc: "Traditional Tamil sweet drink with aromatic khus-khus seeds.",
              price: "On Request",
            },
            {
              name: "Mohabat Ka Sarabath",
              desc: "A Mughlai rose-milk drink layered with basil seeds and watermelon.",
              price: "On Request",
            },
            {
              name: "Arabian Grape Juice",
              desc: "Chilled premium grape juice with a rich Arabian twist.",
              price: "On Request",
            },
            {
              name: "Watermelon Juice",
              desc: "Fresh seasonal watermelon juice served ice cold.",
              price: "On Request",
            },
            {
              name: "Nannari Sarbath",
              desc: "Cooling Indian sarsaparilla syrup drink with lime.",
              price: "On Request",
            },
          ],
        },
        {
          id: "soups",
          icon: "🍲",
          image: soupsImg,
          label: "Soups",
          items: [
            {
              name: "Veg Clear Soup",
              desc: "Light and nutritious clear vegetable broth.",
              price: "On Request",
            },
            {
              name: "Veg Chettinad Soup",
              desc: "Spiced vegetable soup with bold Chettinad masala.",
              price: "On Request",
            },
            {
              name: "Sweet Corn Soup (Veg)",
              desc: "Creamy sweet corn soup with a mild seasoning.",
              price: "On Request",
            },
            {
              name: "Hot & Sour Soup (Veg)",
              desc: "Classic Indo-Chinese hot and sour vegetable soup.",
              price: "On Request",
            },
            {
              name: "Tomato Soup",
              desc: "Rich, velvety tomato soup served piping hot.",
              price: "On Request",
            },
            {
              name: "Veg Pepper Soup",
              desc: "Hearty pepper-flavoured vegetable soup.",
              price: "On Request",
            },
            {
              name: "Veg Noodles Soup",
              desc: "Vegetable broth with soft noodles and aromatics.",
              price: "On Request",
            },
            {
              name: "Mutton Bone Soup",
              desc: "Slow-simmered mutton bone broth packed with collagen and spice.",
              price: "On Request",
            },
            {
              name: "Mutton Pepper Soup",
              desc: "Bold pepper-spiced mutton soup, a true warming classic.",
              price: "On Request",
            },
            {
              name: "Mutton Clear Soup",
              desc: "Light, flavourful clear mutton broth.",
              price: "On Request",
            },
            {
              name: "Mutton Payya Soup",
              desc: "Traditional South Indian trotters soup, slow-cooked overnight.",
              price: "On Request",
            },
            {
              name: "Mutton Chettinad Soup",
              desc: "Aromatic Chettinad-spiced mutton soup.",
              price: "On Request",
            },
            {
              name: "Chicken Clear Soup",
              desc: "Clean, delicate chicken broth with herbs.",
              price: "On Request",
            },
            {
              name: "Hot & Sour Chicken Soup",
              desc: "Indo-Chinese style chicken hot & sour soup.",
              price: "On Request",
            },
            {
              name: "Chicken Chettinad Soup",
              desc: "Peppery Chettinad-style chicken soup.",
              price: "On Request",
            },
            {
              name: "Chicken Noodles Soup",
              desc: "Comforting chicken soup with silky noodles.",
              price: "On Request",
            },
            {
              name: "Chicken Manchow Soup",
              desc: "Thick Indo-Chinese chicken manchow soup with crispy noodles.",
              price: "On Request",
            },
            {
              name: "Pepper Chicken Soup",
              desc: "Bold black pepper chicken broth with ginger.",
              price: "On Request",
            },
          ],
        },
        {
          id: "breads",
          icon: "🫓",
          image: breadsImg,
          label: "Breads",
          items: [
            {
              name: "Naan (Plain / Butter)",
              desc: "Soft leavened flatbread from the tandoor, plain or buttered.",
              price: "On Request",
            },
            {
              name: "Kashmiri Naan",
              desc: "Sweet stuffed naan with dry fruits and saffron.",
              price: "On Request",
            },
            {
              name: "Rumali Roti",
              desc: "Paper-thin bread cooked on an inverted wok, ideal with rich gravies.",
              price: "On Request",
            },
            {
              name: "Parotta (Bun / Coin / Nool)",
              desc: "Layered South Indian flatbread in three signature styles.",
              price: "On Request",
            },
            {
              name: "Chapatti",
              desc: "Soft whole-wheat flatbread, a wholesome accompaniment.",
              price: "On Request",
            },
            {
              name: "Idiyappam",
              desc: "Delicate rice-flour string hoppers, perfect with gravies.",
              price: "On Request",
            },
          ],
        },
        {
          id: "biryanis",
          icon: "🍛",
          image: biryaniImg,
          label: "Signature Biryanis",
          items: [
            {
              name: "Mutton Biryani (Seeraga Samba / Basmati)",
              desc: "Slow-cooked succulent mutton layered with fragrant rice.",
              price: "On Request",
            },
            {
              name: "Chicken Biryani (Seeraga Samba / Basmati)",
              desc: "Our majestic signature biryani rich in saffron and authentic spices.",
              price: "On Request",
            },
            {
              name: "Mushroom Biryani",
              desc: "Earthy mushrooms layered with aromatic spiced rice.",
              price: "On Request",
            },
            {
              name: "Paneer Biryani",
              desc: "Tender cottage cheese cubes with fragrant basmati rice.",
              price: "On Request",
            },
          ],
        },
        {
          id: "rice",
          icon: "🍚",
          image: riceImg,
          label: "Rice Varieties",
          items: [
            {
              name: "Ghee Rice",
              desc: "Aromatic basmati rice tempered in pure desi ghee.",
              price: "On Request",
            },
            {
              name: "Veg Pulao",
              desc: "Lightly spiced vegetable pulao with mixed fresh vegetables.",
              price: "On Request",
            },
            {
              name: "Dal Rice",
              desc: "Comforting steamed rice served with flavourful lentil dal.",
              price: "On Request",
            },
            {
              name: "Curd Semiya",
              desc: "Chilled vermicelli tossed in fresh yogurt with tempering.",
              price: "On Request",
            },
            {
              name: "Curd Rice",
              desc: "South Indian classic — steamed rice with cooling yogurt.",
              price: "On Request",
            },
          ],
        },
        {
          id: "gravies",
          icon: "🥘",
          image: graviesImg,
          label: "Gravies",
          items: [
            {
              name: "Paneer Butter Masala",
              desc: "Cottage cheese in a rich, creamy tomato-butter gravy.",
              price: "On Request",
            },
            {
              name: "Mix Vegetable Masala",
              desc: "Seasonal vegetables in a bold spiced onion-tomato gravy.",
              price: "On Request",
            },
            {
              name: "Vegetable Chettinad Masala",
              desc: "Fiery Chettinad-spiced vegetable masala.",
              price: "On Request",
            },
            {
              name: "Navarathna Kuruma",
              desc: "Nine-vegetable kurma in a creamy coconut-cashew gravy.",
              price: "On Request",
            },
            {
              name: "Baby Corn Masala",
              desc: "Tender baby corn in a thick onion-tomato sauce.",
              price: "On Request",
            },
            {
              name: "Veg White Stew",
              desc: "Mild Kerala-style coconut milk vegetable stew.",
              price: "On Request",
            },
            {
              name: "Kadai Paneer",
              desc: "Paneer and capsicum tossed in rustic kadai masala.",
              price: "On Request",
            },
            {
              name: "Butter Chicken Gravy",
              desc: "Classic makhani-style tender chicken in silky butter tomato sauce.",
              price: "On Request",
            },
            {
              name: "Chicken Karaikudi Gravy",
              desc: "Authentic Karaikudi-style spicy chicken curry.",
              price: "On Request",
            },
            {
              name: "Salem Chicken Gravy",
              desc: "Signature Salem-style chicken curry with robust local spices.",
              price: "On Request",
            },
            {
              name: "Pepper Chicken Masala",
              desc: "Bold black pepper chicken in a thick dry-style gravy.",
              price: "On Request",
            },
            {
              name: "Shadi Ka Lal Chicken",
              desc: "Wedding-style fiery red chicken gravy.",
              price: "On Request",
            },
            {
              name: "Chicken White Stew",
              desc: "Mild and creamy coconut milk chicken stew.",
              price: "On Request",
            },
          ],
        },
        {
          id: "dry-items",
          icon: "🍗",
          image: dryItemsImg,
          label: "Dry Items & BBQ",
          items: [
            {
              name: "Grill Chicken",
              desc: "Whole chicken pieces marinated and grilled over live flame.",
              price: "On Request",
            },
            {
              name: "Peri Peri Chicken",
              desc: "Fiery Portuguese-style peri peri glazed grilled chicken.",
              price: "On Request",
            },
            {
              name: "Honey BBQ Chicken",
              desc: "Sweet and smoky honey BBQ glazed chicken pieces.",
              price: "On Request",
            },
            {
              name: "Smoky BBQ Chicken",
              desc: "Slow-smoked BBQ chicken with bold charred flavours.",
              price: "On Request",
            },
            {
              name: "Triple Flavour Chicken",
              desc: "Three signature marinades on one platter.",
              price: "On Request",
            },
            {
              name: "Hariyalli Kebab",
              desc: "Green herb-marinated tender chicken kebab.",
              price: "On Request",
            },
            {
              name: "BBQ Wings",
              desc: "Crispy chicken wings coated in smoky BBQ sauce.",
              price: "On Request",
            },
            {
              name: "Chicken 65 (Bone / Boneless)",
              desc: "Crunchy deep-fried spiced chicken — the ultimate crowd-pleaser.",
              price: "On Request",
            },
            {
              name: "Chicken Pepper Fry",
              desc: "Dry pepper-tossed chicken with curry leaves and spices.",
              price: "On Request",
            },
            {
              name: "Chicken Sukka",
              desc: "Mangalorean-style dry chicken with roasted coconut masala.",
              price: "On Request",
            },
            {
              name: "Chicken Lollipop",
              desc: "French-trimmed chicken wings in a tangy glaze.",
              price: "On Request",
            },
            {
              name: "Hariyalli Chicken",
              desc: "Mint & coriander marinated chicken, grilled to perfection.",
              price: "On Request",
            },
            {
              name: "Leg 65",
              desc: "Spicy deep-fried chicken leg pieces.",
              price: "On Request",
            },
            {
              name: "Yercaud Milagu Varuval",
              desc: "Signature hill-style pepper dry fry from Yercaud.",
              price: "On Request",
            },
            {
              name: "Gobi 65",
              desc: "Crispy spiced cauliflower florets, the vegetarian star.",
              price: "On Request",
            },
            {
              name: "Veg Fish Fry (Plantain)",
              desc: "Raw banana slices coated in spiced batter and fried.",
              price: "On Request",
            },
            {
              name: "Veg Mutton Sukka (Jackfruit)",
              desc: "Tender jackfruit cooked in Sukka-style coconut masala.",
              price: "On Request",
            },
            {
              name: "Veg Lollipop",
              desc: "Crispy vegetable lollipops — perfect party starter.",
              price: "On Request",
            },
            {
              name: "Paneer 65",
              desc: "Marinated cottage cheese bites, deep-fried to golden crisp.",
              price: "On Request",
            },
            {
              name: "Paneer Tikka",
              desc: "Smoky tandoor-grilled paneer with bell peppers and spices.",
              price: "On Request",
            },
            {
              name: "Mushroom Pakoda",
              desc: "Crispy batter-fried mushrooms with spiced coating.",
              price: "On Request",
            },
          ],
        },
        {
          id: "live-counters",
          icon: "🔥",
          image: liveCountersImg,
          label: "Live Counters",
          items: [
            {
              name: "Parotta Counter",
              desc: "Freshly made layered parottas rolled and served hot live.",
              price: "On Request",
            },
            {
              name: "Dosa Varieties Counter",
              desc: "Crispy dosas made to order with a range of fillings.",
              price: "On Request",
            },
            {
              name: "Shawarma Counter",
              desc: "Freshly rolled chicken shawarmas with garlic sauce.",
              price: "On Request",
            },
            {
              name: "Pani Puri Counter",
              desc: "Classic street-style pani puri with tangy tamarind water.",
              price: "On Request",
            },
            {
              name: "Thatu Vada Set Counter",
              desc: "South Indian set meal with vada, sambar & chutneys.",
              price: "On Request",
            },
            {
              name: "Dessert Counter",
              desc: "Assorted Indian sweets and desserts served live.",
              price: "On Request",
            },
            {
              name: "Chocolate Counter",
              desc: "Live chocolate fountain and chocolate dessert station.",
              price: "On Request",
            },
            {
              name: "Ice Cream Counter",
              desc: "Multiple ice cream flavours scooped fresh live.",
              price: "On Request",
            },
            {
              name: "Sweet Beda Counter",
              desc: "Betel leaf sweet wraps with assorted fillings.",
              price: "On Request",
            },
            {
              name: "Fruit Salad Counter",
              desc: "Fresh seasonal fruit salad dressed live.",
              price: "On Request",
            },
            {
              name: "Beverages Counter",
              desc: "Hot and cold beverages station with multiple choices.",
              price: "On Request",
            },
            {
              name: "Chaat Counter",
              desc: "Assorted North Indian chaat items served fresh.",
              price: "On Request",
            },
            {
              name: "Turkey Ice Cream Counter",
              desc: "Rolled Turkish-style ice cream made live at the counter.",
              price: "On Request",
            },
          ],
        },
        {
          id: "sweets-desserts",
          icon: "🍮",
          image: sweetsDessertsImg,
          label: "Sweets & Desserts",
          items: [
            {
              name: "Gulab Jamun",
              desc: "Soft golden milk-solid balls soaked in rose-flavoured sugar syrup.",
              price: "On Request",
            },
            {
              name: "Kesari",
              desc: "South Indian semolina halwa with saffron and cashews.",
              price: "On Request",
            },
            {
              name: "Rasagulla",
              desc: "Soft spongy cottage cheese balls in light sugar syrup.",
              price: "On Request",
            },
            {
              name: "Pal Payasam",
              desc: "Rich creamy South Indian milk and rice kheer.",
              price: "On Request",
            },
            {
              name: "Laddu",
              desc: "Classic round Indian sweet made with chickpea flour and ghee.",
              price: "On Request",
            },
            {
              name: "Semiya Payasam",
              desc: "Vermicelli cooked in sweetened milk with cardamom.",
              price: "On Request",
            },
            {
              name: "Mysore Pak",
              desc: "Rich ghee-laden traditional Mysore sweet.",
              price: "On Request",
            },
            {
              name: "Basundi",
              desc: "Reduced sweetened milk dessert with saffron and nuts.",
              price: "Premium",
            },
            {
              name: "Bread Halwa",
              desc: "Caramelised bread pudding with ghee, sugar and cardamom.",
              price: "Premium",
            },
            {
              name: "Carrot Halwa",
              desc: "Slow-cooked grated carrot halwa in ghee and milk.",
              price: "Premium",
            },
            {
              name: "Ilaneer Payasam",
              desc: "Tender coconut payasam with coconut milk and jaggery.",
              price: "Premium",
            },
            {
              name: "Ice Cream with Jamun",
              desc: "Vanilla ice cream served alongside warm gulab jamun.",
              price: "Premium",
            },
            {
              name: "Dry Fruit Halwa",
              desc: "Luxurious halwa loaded with premium mixed dry fruits.",
              price: "Premium",
            },
            {
              name: "Sai Bhakri (Sai Thukoda)",
              desc: "Flaky sweet flatbread dessert coated in sugar.",
              price: "Premium",
            },
            {
              name: "Vanilla Ice Cream",
              desc: "Classic smooth vanilla soft serve.",
              price: "On Request",
            },
            {
              name: "Chocolate Ice Cream",
              desc: "Rich dark chocolate ice cream.",
              price: "On Request",
            },
            {
              name: "Jackfruit Ice Cream",
              desc: "Exotic jackfruit flavoured artisanal ice cream.",
              price: "On Request",
            },
            {
              name: "Cassata Slice",
              desc: "Layered Sicilian-style ice cream with nuts and fruits.",
              price: "On Request",
            },
            {
              name: "Madurai Jigarthanda",
              desc: "Iconic Madurai cold dessert drink with sarsaparilla and ice cream.",
              price: "On Request",
            },
            {
              name: "Dry Fruit Falooda",
              desc: "Layered falooda dessert drink with dry fruits and rose syrup.",
              price: "On Request",
            },
            {
              name: "Strawberry Ice Cream",
              desc: "Fresh strawberry flavoured creamy ice cream.",
              price: "On Request",
            },
          ],
        },
      ],
    },
    blogPage: {
      pageBanner: {
        bgImage: heroBg,
        eyebrow: "Our Stories",
        title: "Nawabi Blog & Insights",
        breadcrumbs: [
          { label: "Home", to: "/" },
          { label: "Blog", to: "/blog" },
        ],
      },
      blogs: [
        {
          id: "1",
          slug: "why-halal-certification-matters",
          title: "Why 100% Halal Certification Matters for Your Event",
          date: "May 10, 2026",
          author: "Chef Rahman",
          category: "Catering Standards",
          excerpt:
            "Discover the importance of strictly verified Halal catering for peace of mind at your grand celebrations.",
          content:
            "<h2>Introduction</h2><p>When planning a grand event, the purity and authenticity of the food are just as important as the taste. While flashy decorations dominate headlines, guests are increasingly turning to a quieter, more consistent need: complete peace of mind regarding their food.</p><p>At Nawabi Caterers, we guarantee 100% Halal certification for every single ingredient, especially our meats. Instead of cutting corners, we aim to deliver uncompromising quality, ensuring returns that mirror your highest expectations.</p><h2>Why 100% Halal is Gaining Traction</h2><p>One of the biggest reasons strict Halal catering has gained traction is its simplicity. Hosts don't need to monitor the kitchen daily or stress over cross-contamination. With a certified Halal caterer, you're guaranteeing purity across the board—which spreads goodwill and smooths out the dining experience.</p><div class=\"pl-4 md:pl-8 mt-6 flex flex-col gap-2\"><h3>1. Uncompromising Separation</h3><p>Many caterers claim to offer Halal menus while using the same equipment for non-Halal dishes. Since we don't require shared kitchens, our cross-contamination risk remains minimal—often exactly 0%.</p><h3>2. Broad Ethical Sourcing</h3><p>A single Halal certification gives you exposure to hundreds of ethical farming practices. This spreads out the benefits and limits the impact of poor quality ingredients on your final dishes.</p><h3>3. Passive Yet Powerful Hygiene</h3><p>Halal preparation follows a passive strategy of strict cleanliness, which historically outperforms most standard catering practices over time—especially when serving large crowds.</p><h3>4. Complete Transparency</h3><p>You know exactly what you're serving your guests. The kitchen's practices reflect the underlying Islamic guidelines and are updated regularly.</p></div>",
          image: indianWeddingFeast,
          metaTitle: "Why 100% Halal Certification Matters | Nawabi Caterers",
          metaDescription:
            "Learn why strict 100% Halal certification is crucial for outdoor catering and how Nawabi Caterers ensures purity and peace of mind.",
          keywords:
            "Halal catering, 100% Halal, Muslim wedding catering, Tamil Nadu caterers",
        },
        {
          id: "2",
          slug: "planning-a-royal-wedding-menu",
          title: "How to Plan a Royal Non-Veg Wedding Menu",
          date: "April 22, 2026",
          author: "Chef Tamil",
          category: "Weddings",
          excerpt:
            "A step-by-step guide to selecting the perfect combination of biryanis, gravies, and starters for your big day.",
          content:
            "<h2>Introduction</h2><p>Over the last two decades, a subtle yet powerful shift has transformed wedding catering. While traditional banana leaf meals once dominated, hosts today are increasingly turning to a more dynamic option: the royal non-veg feast.</p><p>A royal wedding menu is designed to replicate the grandeur of Nawabi feasts—featuring Biryani, rich gravies, and live starters. Instead of trying to please everyone with basic options, they aim to be the highlight of the event, delivering flavors that mirror true celebration.</p><h2>Why Royal Menus Are Gaining Traction</h2><p>One of the biggest reasons royal non-veg menus have gained traction is their impact. You don't need to stress over whether guests will like the food. With a well-planned non-veg spread, you're offering a little bit of everything—which spreads joy and smooths out the entire reception experience.</p><div class=\"pl-4 md:pl-8 mt-6 flex flex-col gap-2\"><h3>1. Low Stress Planning</h3><p>Royal menus typically have lower stress ratios than piecing together a menu yourself. Since they don't require you to guess what works together, the hassle remains minimal.</p><h3>2. Broad Culinary Diversification</h3><p>A single royal menu can give your guests exposure to dozens of unique flavor profiles. This spreads out the culinary risk and limits the impact of any one dish not being someone's favorite.</p><h3>3. Passive Yet Powerful Impressions</h3><p>Serving premium dishes like Mutton Dum Biryani follows a passive strategy for impressing guests, which historically outperforms most standard menus over time.</p><h3>4. Complete Menu Transparency</h3><p>You know exactly what your guests are eating. The menu's offerings reflect traditional Nawabi recipes and are prepared fresh right before the event.</p></div>",
          image: indianBiryaniSpread,
          metaTitle: "How to Plan a Royal Wedding Menu | Nawabi Caterers",
          metaDescription:
            "A guide to selecting the best non-veg dishes for your Tamil Nadu wedding, from Mutton Biryani to Chettinad Chicken.",
          keywords:
            "Wedding menu, Non-veg catering, Biryani catering, Tamil wedding food",
        },
        {
          id: "3",
          slug: "the-secret-to-perfect-biryani",
          title: "The Secret to the Perfect Dum Biryani",
          date: "March 15, 2026",
          author: "Chef Rahman",
          category: "Recipes & Secrets",
          excerpt:
            "What makes the Nawabi Mutton Dum Biryani so special? It's all in the slow-cooking technique and the quality of spices.",
          content:
            "<h2>Introduction</h2><p>Over the centuries, a subtle yet powerful technique has transformed Indian cooking. While quick-cook methods and pressure cookers once dominated modern kitchens, chefs today are increasingly turning to a quieter, more consistent option: Dum cooking.</p><p>Dum cooking is a traditional method designed to replicate the slow, pressurized cooking of ancient royal kitchens. Instead of trying to rush the process, it aims to trap the steam, delivering flavors that mirror the absolute best of Nawabi cuisine.</p><h2>Why Dum Biryani is Gaining Traction</h2><p>One of the biggest reasons Dum Biryani has gained traction is its incredible depth of flavor. You don't need to monitor the pot daily or stress over adding extra spices. With the Dum method, you're locking in a little bit of everything—which spreads the aroma and smooths out the meat's texture.</p><div class=\"pl-4 md:pl-8 mt-6 flex flex-col gap-2\"><h3>1. Low Moisture Loss</h3><p>Dum cooking typically has lower moisture loss ratios than standard open-pot boiling. Since it doesn't require constant stirring, the juices remain locked in—often resulting in the most tender meat possible.</p><h3>2. Broad Flavor Diversification</h3><p>A single Dum pot can give your rice exposure to dozens of different whole spices. This spreads out the aromatic profile and limits the impact of any one overpowering spice.</p><h3>3. Passive Yet Powerful Cooking</h3><p>Sealing the pot follows a passive cooking strategy, which historically has outperformed most active cooking methods over time—especially for large batches of biryani.</p><h3>4. Process Transparency</h3><p>You know exactly how your food is being prepared. The cooking style reflects ancient traditions and guarantees an authentic taste every single time.</p></div>",
          image: nawabiChefBiryani,
          metaTitle: "The Secret to Perfect Dum Biryani | Nawabi Caterers",
          metaDescription:
            "Discover the traditional slow-cooking techniques and fresh spices that make Nawabi Caterers' Dum Biryani famous.",
          keywords:
            "Dum Biryani, Mutton Biryani, Biryani recipe, Traditional catering",
        },
      ],
    },
  },
  components: {
    // Add components text as you go
  },
};
